/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */

/**
 * Shared framer-motion presets. Hoisted to module scope so that the same
 * object reference is passed on every render (no re-render churn, memo-safe).
 */
export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1];

export const FADE_UP_SM = {
  initial: { opacity: 0, y: -8 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.25 },
};

export const FADE_UP_PILL = {
  initial: { opacity: 0, y: -4 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0 },
  transition: { duration: 0.18 },
};

export const FADE_UP_BANNER = {
  initial: { opacity: 0, y: -6 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.2 },
};

export const HERO_ENTER = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: EASE_OUT_EXPO },
};

export const HERO_ENTER_DELAYED = {
  ...HERO_ENTER,
  transition: { ...HERO_ENTER.transition, delay: 0.1 },
};

export const CARD_HOVER = {
  whileHover: { y: -4 },
  whileTap: { scale: 0.995 },
  transition: { type: 'spring', stiffness: 320, damping: 24 },
};
